module.exports = {
frame:{
}
};



//////////////////
// WEBPACK FOOTER
// ./cfg/frames-config.js
// module id = 19
// module chunks = 0